<template>
  <div id="likeLayout">
    <b-modal :active.sync="isImageModalActive">
      <img :src="this.ImageModalSrc">
    </b-modal>

    <!-- MENU HEADER  -->
    <div class="tools">
      <button
        class="button back"
        @click="goBack"
      >
        <b-icon
          class="queueicon"
          pack="fas"
          icon="chevron-left"
          size="is-small"
        ></b-icon>
      </button>
      <div class="title">
        <h1 class="">{{ current.name }}</h1>
      </div>

      <div class="rightMenu">
        <div
          id="sheetfilter"
          class="sheetfilter"
        >
          <b-dropdown>
            <template v-if="currentFilteredSheet === null">
              <button
                class="filterButton"
                style="border:2px solid white;"
                slot="trigger"
              >
                <span class="filterByColorText">{{ $t('wordcloud.AllSheet') }}</span>
              </button>
            </template>
            <template v-else>
              <button
                class="filterButton"
                style="border:2px solid white;"
                slot="trigger"
              >
                <span class="filterByColorText">{{this.currentFilteredSheet}}</span>
              </button>
            </template>
            <b-dropdown-item @click="filterSheet(null)">{{ $t('filter.reset') }}</b-dropdown-item>

            <template v-for="sheet in this.$store.state.board.current.sheets">
              <b-dropdown-item
                @click="filterSheet(sheet)"
                :key="sheet.id"
              >{{sheet.name}}</b-dropdown-item>
            </template>

          </b-dropdown>
        </div>

        <div
          id="colorfilter"
          class="colorfilter"
        >
          <b-dropdown>
            <template v-if="currentFilteredColor === null">
              <button
                class="filterButton"
                style="border:2px solid white;"
                slot="trigger"
              >
                <span class="filterByColorText">{{ $t('wordcloud.AllColors') }}</span>
              </button>
            </template>
            <template v-else>
              <button
                class="filterButton"
                :style="'background-color:'+currentFilteredColor+';color:black;border:2px solid #fff0;'"
                slot="trigger"
              >
                <span class="filterByColorText">{{ $t('filter.color') }}</span>
              </button>
            </template>
            <b-dropdown-item @click="filterColor(null)">{{ $t('filter.reset') }}</b-dropdown-item>
            <template
              v-for="color in colors"
              v-key="color"
            >
              <b-dropdown-item
                v-bind:key="color"
                @click="filterColor(color)"
              >
                <b-icon
                  pack="fas"
                  icon="square"
                  size="is-small"
                  :style="'color:'+color"
                ></b-icon>
              </b-dropdown-item>
            </template>
          </b-dropdown>
        </div>
      </div>

    </div>
    <!-- FIN MENU HEADER -->

    <!-- ZONE CONTENANT LES POSTITS TRIES -->
    <div
      class="contentLayout"
      id="svgBoard"
    >
      <ul class="zonepostsit">
        <li
          class="gabaritPostLike"
          v-for="post in even(postlist)"
          :key="post.id"
        >
          <div
            id="colorRibbon"
            :style="'background-color:'+post.couleur"
          />
          <p id="creationDate">{{displayDate(post)}} </p>
          <div class="contenuPostLike">
            {{post.contenu}}
          </div>
          <div class="bandeauPostLike">
            <a
              @click="openPopupLink(post)"
              :class="{non_active: !post.link}"
            >
              <b-icon
                class="editbutton"
                pack="fas"
                icon="link"
                size="is-small"
              ></b-icon>
            </a>
            <a
              @click="loadImagePopup(url_media+'uploads/brainstorming/medias/'+post.media)"
              :class="{non_active: !post.media}"
            >
              <img
                id="addPhoto"
                src="/static/add_photo.png"
                alt=""
              />
            </a>
            <thumbsUpBlack class="svgIcon" />
            {{ post.like }}
          </div>
        </li>
      </ul>

      <div class="clearfix"></div>
    </div>

  </div>
</template>

<script>
import thumbsUpBlack from '../assets/svg/thumbsUpBlack.svg'

import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('board')
export default {
  components: {
    thumbsUpBlack

  },
  data () {
    return {
      FiltreActifColor: '',
      FiltreActifSheet: null,
      currentFilteredColor: null,
      currentFilteredSheet: null,
      imageUrl: '',
      ImageModalSrc: null,
      isImageModalActive: false,
      loaded: false,
      url_media: process.env.URL_MEDIA,
      // colors: [
      //   'rgb(112,209,248)',
      //   'rgb(238,110,110)',
      //   'rgb(96,205,199)',
      //   'rgb(245,235,153)',
      //   'rgb(223,173,53)',
      //   'rgb(96,76,141)',
      //   'rgb(76,108,160)'
      // ]
    }
  },
  computed: {
    colors () {
      return JSON.parse(this.current.colours)
    },
    ...mapState({
      current: 'current',
      postlist: 'currentBoardPost'
    })
  },
  watch: {
    current: {
      handler: function (val) {
        if (this.current.id !== undefined && this.loaded === false) {
          this.loaded = true
          var data = { board: this.current }
          this.$store.dispatch('board/loadBoardData', data)

          var room = 'Room_Brain_' + this.current.id
          this.$socket.emit('room', room)

          if (this.current.template_id !== null) {
            document.getElementById('svgBoard').setAttribute('style', "background:url('" + process.env.URL_MEDIA + this.current.template.url + "')no-repeat 0% 0%;background-size: cover;")
          } else {
            document.getElementById('svgBoard').setAttribute('style', 'background: url("/static/quadrillage.png") repeat scroll 0% 0%')
          }
        }
      },
      deep: true,
      immediate: true
    },
    postlist: {
      handler: function (val) {
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    displayDate (post) {
      function formatedMonth (date) {
        var month = date.getMonth() + 1
        return month < 10 ? '0' + month : '' + month // ('' + month) for string result
      }
      function formatedDay (date) {
        var day = date.getDate()
        return day < 10 ? '0' + day : '' + day // ('' + month) for string result
      }
      let creationEpoch = new Date(Date.parse(post.created_at.replace(/\s/, 'T'))) // Le 'replace 'T' sert à formatter la date pour que safari puisse la lire correctement)
      return `${formatedDay(creationEpoch)}/${formatedMonth(creationEpoch)}/${creationEpoch.getFullYear()} - ${creationEpoch.getHours() + 1}:${creationEpoch.getMinutes() + 1}`
    },
    goBack () {
      window.history.back()
    },

    even: function (arr) {
      var postsRetour = arr

      /* Permet de n'afficher que les postit appartenant à une feuille existante (traitement du cas de suppresion de feuille) */
      if (this.$store.state.board.current.sheets != undefined) {
        var feuillesPossibles = []
        this.$store.state.board.current.sheets.forEach(function (element) {
          feuillesPossibles.push(element.id)
        })
        postsRetour = postsRetour.filter(p => feuillesPossibles.indexOf(p.sheet_id) != -1)
      }
      /* fin du traitement */

      if (this.FiltreActifColor) { postsRetour = postsRetour.filter(p => p.couleur === this.FiltreActifColor) }
      if (this.FiltreActifSheet) { postsRetour = postsRetour.filter(p => p.sheet_id === this.FiltreActifSheet) }

      return postsRetour.slice().sort(function (a, b) {
        return b.like - a.like
      })
    },
    openPopupLink (lePost) {
      if (lePost.link.length > 40) { lePost.messagePopup = lePost.link.substr(0, 40) + '...' } else { this.messagePopup = lePost.link }
      this.$buefy.dialog.confirm({
        title: this.$i18n.t('post.link.popup.title'),
        message: this.$i18n.t('post.link.popup.message') + '<br><br>' + this.messagePopup,
        type: 'is-info',
        cancelText: this.$i18n.t('post.link.popup.non'),
        confirmText: this.$i18n.t('post.link.popup.oui'),
        hasIcon: true,
        onConfirm: () => window.open(lePost.link, '_blank')
      })
    },
    loadImagePopup (mediaURL) {
      if (mediaURL) {
        this.ImageModalSrc = mediaURL
        this.isImageModalActive = true
      }
    },
    filterColor (color) {
      this.currentFilteredColor = color
      if (color) {
        this.FiltreActifColor = color
      } else {
        this.FiltreActifColor = ''
      }
    },
    filterSheet (sheet) {
      if (sheet) {
        this.currentFilteredSheet = sheet.name
        this.FiltreActifSheet = sheet.id
      } else {
        this.currentFilteredSheet = null
        this.FiltreActifSheet = null
      }
    }

  },
  sockets: {
    connect () {
      this.$store.commit('board/SOCKET_STATE', { state: true })
    },
    disconnect () {
      this.$store.commit('board/SOCKET_STATE', { state: false })
    },
    channel (data) {
      var decodeddata = JSON.parse(decodeURIComponent(data))
      if (decodeddata.type === 'CREATE') {
        this.$store.commit('board/NEW_POST', decodeddata.post)
      } else if (decodeddata.type === 'UPDATE') {
        this.$store.commit('board/UPDATE_POST', decodeddata.post)
      } else if (decodeddata.type === 'NEW_SHEET') {
        this.$store.commit('board/NEW_SHEET', decodeddata.post)
      } else if (decodeddata.type === 'DESTROY_SHEET') {
        this.$store.commit('board/REMOVE_SHEET', decodeddata.post)
      } else if (decodeddata.type === 'UPDATE_SHEET') {
        this.$store.commit('board/UPDATE_SHEET', decodeddata.post)
      }
    }
  }

}
</script>

<style scoped>
.back {
  float: left;
  margin: 0px;
  font-size: 18px;
  background-color: rgba(0, 0, 0, 0);
  color: #f8df40;
  border: none;
}

.clearfix {
  clear: both;
}

.filterButton {
  background-color: white;
  color: grey;
}

.filterByColorText {
  margin-right: 20px;
}

.filterByColorText::after {
  content: " ";
  height: 0;
  position: absolute;
  color: black;
  top: 50%;
  right: 5px;
  width: 0;
  border: 6px solid rgba(0, 0, 0, 0);
  border-top-color: rgba(0, 0, 0, 0);
  border-top-color: #424a60 !important;
  margin-top: -3px;
  z-index: 1;
}

.gabaritPostLike {
  float: left;
  background: white;
  width: 250px;
  min-height: 60px;
  position: relative;
  z-index: 1;
  margin: 10px;
}

.bandeauPostLike {
  padding: 0px 5px;
}

.contenuPostLike {
  padding: 5px 15px;
  font-size: 0.9em;
}

.contentLayout {
  position: relative;
  min-height: 100%;
  width: 100%;
}

#likeLayout {
  width: 100%;
  height: 100%;
}

/* barre outils */
.tools {
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  z-index: 9;
  margin: auto;
  top: 0;
  left: 0;
  background-color: #424a60;
  border-radius: 0;
  padding: 8px 5px;
  align-items: center;
}
.rightMenu {
  display: flex;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  text-align: right;
  vertical-align: top;
  flex-flow: row wrap;
  margin-left: auto;
}
.rightMenu > * {
  margin: auto;
  padding: 0 10px;
}
.title {
  color: white;
  float: left;
  margin: 0;
  width: max-content;
  font-size: 18px;
  margin: 0 0 0 5px;
  text-align: left;
  display: flex;
  flex-flow: row nowrap;
}
.title > img {
  display: inline-block;
  vertical-align: top;
  max-width: 100%;
  max-height: 40px;
}
.title > h1 {
  display: inline-block;
  padding: 0px 0 0 10px;
  width: 100%;
}
.colorfilter,
.sheetfilter {
  display: inline-block;
  vertical-align: top;
  z-index: 100;
  margin: 0 0 0 0;
  height: 30px;
}

.button {
  height: 30px;
}

#colorRibbon {
  height: 6px;
}

#creationDate {
  font-size: 9px;
  color: gray;
  font-style: italic;
  padding: 3px;
}

.non_active {
  opacity: 0.3;
  pointer-events: none;
}
.editbutton {
  color: black;
  cursor: pointer;
  width: 20px;
  height: 20px;
}
.editbutton:hover {
  color: #fff;
}

.flip-list-move {
  transition: transform 1s;
}

.flip-list-item {
  transition: all 1s;
  /* display: inline-block;*/
}
.flip-list-enter,
.flip-list-leave-to {
  opacity: 0;
  transform: translateY(30px);
}
.flip-list-leave-active {
  position: absolute;
}

#addPhoto {
  height: 16px;
  margin-left: 2px;
  margin-right: -5px;
}
.svgIcon {
  top: 12px;
  position: relative;
  left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderByLikes.vue